import { createReducer } from "reduxsauce";

import importer from "common/importer";

const { INITIAL_STATE } = importer("Stores/Chatbot/InitialState", null);
const { ChatbotTypes } = importer("Stores/Chatbot/Actions", null);
const getChatbotResponseLoading = (state, props) => {
  return {
    ...state,
    getChatbotResponseLoading: true,
    getChatbotResponseSuccess: null,
    getChatbotResponseFailure: null,
  };
};

// const getChatbotInitialState = (state) => ({
//   getChatbotResponseLoading: false,
//   getChatbotResponseSuccess: null,
//   getChatbotResponseFailure: null,
// });

const getChatbotResponseSuccess = (state, { res }) => {
  return {
    ...state,
    getChatbotResponseLoading: false,
    getChatbotResponseSuccess: res,
    getChatbotResponseFailure: null,
  };
};

const setChatbotResponseSuccess = (state, { res }) => {
  return {
    ...state,
    getChatbotResponseSuccess: null,
  };
};

const getChatbotResponseFailure = (state, { error }) => {
  return {
    ...state,
    getChatbotResponseLoading: false,
    getChatbotResponseSuccess: null,
    getChatbotResponseFailure: error.message || "",
  };
};

const openChatbot = (state, { openChatbot: shouldChatbotOpen }) => {
  return {
    ...state,
    openChatbot: shouldChatbotOpen,
    getChatbotResponseLoading: false,
  };
};

const setChatbotToGlobalView = (state, { showChatbotGlobally }) => {
  return {
    ...state,
    showGlobally: showChatbotGlobally,
    getChatbotResponseLoading: false,
  };
};

const setChatbotForPageView = (
  state,
  { isInternalVarAvailable, showParticularPage }
) => {
  return {
    ...state,
    showOnParticularPage: showParticularPage,
    particularPageInternalVar: isInternalVarAvailable,
    getChatbotResponseLoading: false,
  };
};

const showHideChatbot = (state, props) => {
  const { bCheckfieldToShowChatbot } = props;
  const { particularPageInternalVar, showGlobally, showOnParticularPage } =
    state || {};
  let result = bCheckfieldToShowChatbot;
  if (bCheckfieldToShowChatbot) {
    if (!particularPageInternalVar) {
      result = showGlobally;
    } else {
      result = showOnParticularPage;
    }
  }

  return {
    ...state,
    showChatbot: result,
    getChatbotResponseLoading: false,
  };
};

export const reducer = createReducer(INITIAL_STATE, {
  [ChatbotTypes.GET_CHATBOT_RESPONSE_LOADING]: getChatbotResponseLoading,
  //   [ChatbotTypes.GET_CHATBOT_INITIAL_STATE]: getChatbotInitialState,
  [ChatbotTypes.GET_CHATBOT_RESPONSE_SUCCESS]: getChatbotResponseSuccess,
  [ChatbotTypes.SET_CHATBOT_RESPONSE_SUCCESS]: setChatbotResponseSuccess,
  [ChatbotTypes.GET_CHATBOT_RESPONSE_FAILURE]: getChatbotResponseFailure,
  [ChatbotTypes.OPEN_CHATBOT]: openChatbot,
  [ChatbotTypes.SET_CHATBOT_TO_GLOBAL_VIEW]: setChatbotToGlobalView,
  [ChatbotTypes.SET_CHATBOT_FOR_PAGE_VIEW]: setChatbotForPageView,
  [ChatbotTypes.SHOW_HIDE_CHATBOT]: showHideChatbot,
});
